import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../config/supabase';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  text-align: center;
`;

const Card = styled.div`
  background: ${props => props.theme.colors.surface};
  border-radius: 12px;
  padding: 40px;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  color: ${props => props.theme.colors.text.primary};
  margin-bottom: 20px;
`;

const Message = styled.p`
  color: ${props => props.theme.colors.text.secondary};
  margin-bottom: 30px;
  line-height: 1.6;
`;

const LoadingSpinner = styled.div`
  border: 4px solid ${props => props.theme.colors.surface};
  border-top: 4px solid ${props => props.theme.colors.accent};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 20px auto;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const AuthConfirm = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');

  useEffect(() => {
    const checkVerification = async () => {
      try {
        // Get the current session
        const { data: { session }, error } = await supabase.auth.getSession();

        if (error) {
          console.error('Session error:', error);
          setStatus('error');
          return;
        }

        if (session) {
          // User is verified and has a session
          setStatus('success');
          // Redirect to the callback URL after a short delay
          setTimeout(() => {
            navigate('/auth/callback');
          }, 2000);
        } else {
          // No session found, verification might have failed
          setStatus('error');
        }
      } catch (error) {
        console.error('Verification error:', error);
        setStatus('error');
      }
    };

    checkVerification();
  }, [navigate]);

  return (
    <Container>
      <Card>
        {status === 'verifying' && (
          <>
            <Title>Verifying Your Email</Title>
            <Message>Please wait while we verify your email address...</Message>
            <LoadingSpinner />
          </>
        )}

        {status === 'success' && (
          <>
            <Title>Email Verified!</Title>
            <Message>
              Your email has been successfully verified. You will be redirected shortly...
            </Message>
          </>
        )}

        {status === 'error' && (
          <>
            <Title>Verification Failed</Title>
            <Message>
              We couldn't verify your email. The link may have expired or is invalid.
              Please try signing up again or contact support if the problem persists.
            </Message>
          </>
        )}
      </Card>
    </Container>
  );
};

export default AuthConfirm; 